import { render, staticRenderFns } from "./DisplayVariants.vue?vue&type=template&id=805b8f60&scoped=true&"
import script from "./DisplayVariants.vue?vue&type=script&lang=js&"
export * from "./DisplayVariants.vue?vue&type=script&lang=js&"
import style0 from "./DisplayVariants.vue?vue&type=style&index=0&id=805b8f60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805b8f60",
  null
  
)

export default component.exports